import { generateTestId } from "@client-shared";

const TEST_ID_PREFIX = "ConnectServiceStep";

/**
 * Static test IDs for ConnectServiceStep component.
 * Use these constants directly for non-iterated elements.
 */
export const CONNECT_SERVICE_STEP_TEST_IDS = {
  container: generateTestId(TEST_ID_PREFIX, "container"),
  title: generateTestId(TEST_ID_PREFIX, "title"),
  description: generateTestId(TEST_ID_PREFIX, "description"),
} as const;

/**
 * Shown in the connection modal when an installer reports failure without supplying an error of its own.
 * Exported so the adjacent test asserts against the same text the component falls back to.
 */
export const INSTALL_FAILURE_FALLBACK_MESSAGES = {
  shopify: "shopify installation failed",
  woocommerce: "woocommerce installation failed",
} as const;
